export const overlayVariant = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
};

export const tapAnimationVariant = {
  scale: 0.9,
  backgroundColor: 'rgba(13, 16, 25, 0.06)',
  backdropFilter: 'blur(10px)',
  boxShadow:
    '0 8px 16px rgba(37, 33, 41, 0.04), 0 0 12px rgba(37, 33, 41, 0.04) 0 0 24px rgba(37, 33, 41, 0.04)',
};
